import MemberInformation from './MemberInformation.component';

export default MemberInformation;
